import * as React from "react";
import videojs from "video.js";

// Styles
import "video.js/dist/video-js.css";

interface IVideoPlayerProps {
    options: videojs.PlayerOptions;
}

const initialOptions: videojs.PlayerOptions = {
    controls: true,
    fluid: true,
    controlBar: {
        volumePanel: {
            inline: true,
        },
    },
};

export const VideoPlayer: React.FC<IVideoPlayerProps> = ({ options }) => {
    const videoNode = React.useRef<HTMLVideoElement>(null); // Изменили здесь
    const player = React.useRef<videojs.Player>();

    React.useEffect(() => {
        if (videoNode.current) {
            player.current = videojs(videoNode.current, {
                ...initialOptions,
                ...options,
            })
        }
        return () => {
            if (player.current) {
                player.current.dispose();
            }
        };
    }, [options]);

    return <video ref={videoNode}
                  className="video-js"
                  onContextMenu={(e) => e.preventDefault()}
    />;
};